export default __webpack_public_path__ + "static/media/s-1.ba9a2049.png";